import { render, staticRenderFns } from "./UploadingParameters.vue?vue&type=template&id=61d295b6"
import script from "./UploadingParameters.vue?vue&type=script&lang=js"
export * from "./UploadingParameters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports